export default function Footer() {
  return <footer className="bg-gray-02 p-10">
    <div className="flex-row gap-3 text-style-compact-03 font-normal text-gray-60 py-[6px]">
      <a href={"https://kendrickpark.notion.site/agreement-privacy?pvs=74"} target="_blank">
        <span className="cursor-pointer">개인정보처리방침</span>
      </a>
      <div className="border border-gray-20 w-px h-[14px] " />
      <a href={"https://kendrickpark.notion.site/agreement-location-info"} target="_blank">
        <span className="cursor-pointer">서비스이용약관</span>
      </a>
    </div>
    <div className="text-gray-60 text-style-body-03 font-normal mt-3">
      <p className="text-gray-80 mb-2">모두의성지 대표자 : 박현규</p>
      사업자등록번호 : 116-13-02939
      <br />
      이메일 : help@modusj.com
      <br />
      통신판매번호 : 2024-수원영통-1349
      <br />
      주소 : 수원시 영통구 이의동 도청로 18번길 26 1210호
      <br />
      전화번호 : 010-5007-2354
      <br />
      <p className="pt-2">
        © 2025 modusj corp. All rights reserved.
      </p>
    </div>
  </footer>
}